@if (httpErrorService.notice(); as notice) {
<section
	role="alert"
	class="fixed inset-x-2 top-2 z-[110000] mx-auto max-w-3xl rounded border border-amber-300 bg-amber-50 p-4 text-sm text-slate-900 shadow-lg">
	@if (httpErrorService.reconnectConfirmation()) {
	<p>
		{{ Dic.httpreconnectwarning.text === 'httpreconnectwarning' ? 'La reconnexion quitte cette page. Copiez vos saisies non
		enregistrées avant de continuer.' : Dic.httpreconnectwarning.text }}
	</p>
	<div class="mt-3 flex flex-wrap justify-end gap-3">
		<button type="button" class="rounded border px-3 py-2" (click)="httpErrorService.cancelReconnect()">
			{{ Dic.cancel.text }}
		</button>
		<button type="button" class="rounded bg-blue-700 px-3 py-2 text-white" (click)="httpErrorService.reconnect()">
			{{ Dic.httpreconnect.text === 'httpreconnect' ? 'Se reconnecter' : Dic.httpreconnect.text }}
		</button>
	</div>
	} @else { @switch (notice) { @case ('screen') {
	<p>
		{{ Dic.screenloadfailed.text === 'screenloadfailed' ? 'Impossible de charger cette page. Vérifiez votre connexion puis
		rechargez la page ou réessayez de l’ouvrir.' : Dic.screenloadfailed.text }}
	</p>
	} @case ('session') {
	<p>
		{{ Dic.httpsessionexpired.text === 'httpsessionexpired' ? 'Votre session a expiré. Vos saisies restent affichées ;
		reconnectez-vous pour continuer.' : Dic.httpsessionexpired.text }}
	</p>
	} @case ('csrf') {
	<p>
		{{ Dic.httpcsrf.text === 'httpcsrf' ? 'Le jeton de sécurité n’est plus valide. Reconnectez-vous pour continuer. Vos saisies
		restent affichées.' : Dic.httpcsrf.text }}
	</p>
	} @case ('forbidden') {
	<p>
		{{ Dic.httpforbidden.text === 'httpforbidden' ? 'Accès refusé. Cette opération n’est pas autorisée. Vous n’avez pas été
		déconnecté.' : Dic.httpforbidden.text }}
	</p>
	} @case ('network') {
	<p>
		{{ Dic.httpnetwork.text === 'httpnetwork' ? 'Connexion au serveur impossible. Vérifiez votre connexion. Si vous enregistriez,
		vérifiez le résultat avant de réessayer.' : Dic.httpnetwork.text }}
	</p>
	} @case ('server') {
	<p>
		{{ Dic.httpserver.text === 'httpserver' ? 'Le serveur n’a pas pu terminer la demande. Vos saisies restent affichées. Vérifiez
		le résultat avant de réessayer un enregistrement.' : Dic.httpserver.text }}
	</p>
	} @case ('response') {
	<p>
		{{ Dic.httpresponse.text === 'httpresponse' ? 'La réponse du serveur est invalide. L’opération ne peut pas être confirmée.
		Vérifiez son résultat avant de réessayer.' : Dic.httpresponse.text }}
	</p>
	} }
	<div class="mt-3 flex flex-wrap justify-end gap-3">
		<button type="button" class="rounded border px-3 py-2" (click)="httpErrorService.dismiss()">
			{{ Dic.close.text === 'close' ? 'Fermer' : Dic.close.text }}
		</button>
		@if (notice === 'session' || notice === 'csrf') {
		<button type="button" class="rounded bg-blue-700 px-3 py-2 text-white" (click)="httpErrorService.requestReconnect()">
			{{ Dic.httpreconnect.text === 'httpreconnect' ? 'Se reconnecter' : Dic.httpreconnect.text }}
		</button>
		}
	</div>
	}
</section>
} @if (loading()) {
<ui-loading type="fullscreen" variant="icon" size="large" />
} @else {
<router-outlet />
}
